<template>
  <div id="app">
    <router-view />
    <v-snackbar
      bottom
      :value="hasErrors"
      timeout="2000"
      @input="resetErrors"
    >
      {{ errorsText }}
    </v-snackbar>
  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  name: 'App',
  components: {},
  computed: {
    ...mapState(['errors']),
    hasErrors() {
      return this.errors.length > 0
    },
    errorsText() {
      return this.errors.join('; ')
    }
  },

  methods: {
    resetErrors() {
      console.log('this.$store.commit(\'RESET_ERRORS\')')
      this.$store.commit('RESET_ERRORS')
    }
  }
}
</script>

<style>
body {
  font-family: Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  margin: 0;
  padding: 0;
}
.v-application .primary--text.v-input--is-focused {
    border-color: #18181E;
    caret-color: #18181E!important;
    color: #18181E!important;
}
.v-application .primary--text.v-label {
    caret-color: #18181E!important;
    color: #18181E!important;
}
.v-input.v-input--is-disabled.v-select .v-input__append-inner .v-input__icon--append{
    display: none!important;
}
.theme--light.v-label--is-disabled {
    color: rgba(0,0,0,.6)!important;
}
.theme--light.v-select .v-select__selection--disabled {
    color: rgba(0,0,0,.87)!important;
}
.color--fix .primary--text.v-icon {
    caret-color: #18181E!important;
    color: #18181E!important;
}
</style>
